import { fetchAll } from './fetchAll';

export type Group = {
  [x: string]: any;
  full_path: string;
  web_url?: string;
};

type GetGitlabGroupProps = {
  baseUrl: string;
  token: string;
  allowedGroups: string[];
  allowedGroupsRegex: string;
};

export async function getGroups({
  baseUrl,
  token,
  allowedGroups,
  allowedGroupsRegex,
}: GetGitlabGroupProps): Promise<Group[]> {
  if (!baseUrl || !token) {
    throw new Error('Proxy base URL or token not available');
  }

  const groups = await fetchAll(`${baseUrl}/gitlab-groups`, token, {
    all_available: 'true',
    per_page: '100',
  });

  // allowedGroups has higher priority than allowedGroupsRegex
  if (allowedGroups?.length) {
    return (
      groups?.filter(
        group =>
          group?.full_path &&
          allowedGroups.some(allowedGroup => allowedGroup === group.full_path),
      ) || []
    );
  }

  if (allowedGroupsRegex) {
    const regex = new RegExp(allowedGroupsRegex, 'ig');
    const filteredGroups =
      groups?.filter(
        group => group?.full_path && regex.test(group.full_path),
      ) || [];
    return filteredGroups;
  }

  return groups;
}
